import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(theme => ({
   buttonmargin:{
    '& button': {
      marginLeft:"10px"
    }
   },
   bg:{
    background:theme.palette.background.bg,
    padding:"5px 15px"
   },   
   mainstep:{
      marginBottom:"40px",
      [theme.breakpoints.down('sm')]: {
        overflowX: 'auto',
        display: 'block',
        width: '100%',
        paddingBottom: 8,
        '& .MuiStepper-root': {
          flexWrap: 'nowrap',
          overflowX: 'auto',
        },
        '& .MuiStep-root': {
          minWidth: 120,
          flex: '0 0 auto',
        },
        '& .MuiStepLabel-label': {
          fontSize: '12px',
          whiteSpace: 'nowrap',
        }
      }
   },
   pt0:{
     paddingTop:"0px !important"
   }
}));
